import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import "bootstrap/dist/css/bootstrap.min.css"; // Make sure Bootstrap CSS is imported
import useTokenStore from "../../../stores/tokens";
import { compatApi } from "../../../utils/Intercepter";

const ResumePage = () => {
  // const currentUser = useLocation().state;
  // const storedUser = sessionStorage.getItem('user');
  // const user = storedUser && JSON.parse(storedUser);
  const { user } = useTokenStore();
  //console.log("user = ", user);

  const userRole = user?.userRole || '';

  const navigate = useNavigate();

  useEffect(() => {
    const requestBody = {
      userEmail: user.userEmail,
      organizationCode: user.currentOrganizationCode
    }

    const fetchData = async () => {
      await compatApi.post('/user/userResumeInfo', requestBody)
        .then(response => response.json())
        .then(data => {
          console.log(data)
          // Format the date fields before setting the state
          setPersonalInfo({
            email: data.userEmail || "",
            userName: data.userName || "",
            birthDate: data.birthDate ? format(new Date(data.birthDate), 'yyyy-MM-dd') : "",
            organizationCode: data.organizationCode || "",
            organizationName: data.organizationName || "",
            department: data.department || "",
            position: data.position || "",
            experience: data.experience || "",
            contact: data.contact || "",
            emergencyContact: data.emergencyContact || "",
            emergencyRel: data.emergencyRel || "",
          });

          // Format the education data
          data.userEducation&&(
            setEducation({
              finalEdu: data.userEducation.finalEdu || "",
              graduationDate: data.userEducation.graduationDate
                ? format(new Date(data.userEducation.graduationDate), 'yyyy-MM')
                : "",
              schoolName: data.userEducation.schoolName || "",
              major: data.userEducation.major || "",
            })
          )

          data.userCareers&&(
          // Format the career data
          setCareers(data.userCareers.map(career => ({
            ...career,
            isActive: career.active,
            startDate: career.startDate ? format(new Date(career.startDate), 'yyyy-MM-dd') : "",
            endDate: career.endDate ? format(new Date(career.endDate), 'yyyy-MM-dd') : "",
          })))
        )

          // Format the certificates data
          setCertificates(data.userCertificates?.map(cert => ({
            ...cert,
            acquisitionDate: cert.acquisitionDate ? format(new Date(cert.acquisitionDate), 'yyyy-MM-dd') : "",
          })) || []
        );

          // Format the projects data
          setProjects(data.userProjectInfos?.map(project => ({
            ...project,
            startDate: project.startDate ? format(new Date(project.startDate), 'yyyy-MM-dd') : "",
            endDate: project.endDate ? format(new Date(project.endDate), 'yyyy-MM-dd') : "",
          })) || []
        );
        })
        .catch(error => {
          console.log(error);
          alert('오류가 발생했습니다.');
        });
    }

    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  const [personalInfo, setPersonalInfo] = useState({
    email: "",
    userName: "",
    birthDate: "",
    organizationCode: "",
    organizationName: "",
    department: "",
    position: "",
    experience: "",
    contact: "",
    emergencyContact: "",
    emergencyRel: "",
  });

  const [education, setEducation] = useState({
    finalEdu: "",
    graduationDate: "",
    schoolName: "",
    major: "",
  });

  const [careers, setCareers] = useState([
    { careerId: "", isActive: "", organizationName: "", startDate: "", endDate: "", task: "" },
  ]);

  const [certificates, setCertificates] = useState([
    { certificateId: "", certificateName: "", acquisitionDate: "" },
  ]);

  const [projects, setProjects] = useState([
    { projectInfoId: "", startDate: "", endDate: "", projectName: "", client: "", task: "" },
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPersonalInfo({ ...personalInfo, [name]: value });
  };

  const handleAddCareer = () => {
    setCareers([...careers, { careerId: "", organizationName: "", startDate: "", endDate: "", task: "" }]);
  };

  const handleAddCertificate = () => {
    setCertificates([...certificates, { certificateId: "", certificateName: "", acquisitionDate: "" }]);
  };

  const handleAddProject = () => {
    setProjects([...projects, { projectInfoId: "", startDate: "", endDate: "", projectName: "", client: "", task: "" }]);
  };

  const handleCareerChange = (index, field, value) => {
    const updatedCareers = careers.map((career, i) =>
      i === index ? { ...career, [field]: value } : career
    );
    setCareers(updatedCareers);
  };

  const handleCertificateChange = (index, field, value) => {
    const updatedCertificates = certificates.map((cert, i) =>
      i === index ? { ...cert, [field]: value } : cert
    );
    setCertificates(updatedCertificates);
  };

  const handleProjectChange = (index, field, value) => {
    const updatedProjects = projects.map((project, i) =>
      i === index ? { ...project, [field]: value } : project
    );
    setProjects(updatedProjects);
  };


  const handleActiveCareer = async (index) => {

    setCareers(prevCareers =>
      prevCareers.map((career, i) =>
        i === index ? { ...career, isActive: true } : { ...career, isActive: false }
      )
    );

    try {
      const response = await compatApi.post('/user/activeUserCareer', careers[index]);

      const message = await response.text();
      console.log(message);

    }
    catch (error) {
      alert(error);
    }

  };

  const handleRemoveCareer = (index) => {
    if (careers[index].careerId) {
      // delete api
      deleteCareer(careers[index]);
    }
    const updatedCareers = careers.filter((_, i) => i !== index);
    setCareers(updatedCareers);
  };

  const handleRemoveCertificate = (index) => {
    if (certificates[index].certificateId) {
      // delete api
      deleteCertificate(certificates[index]);
    }
    const updatedCertificates = certificates.filter((_, i) => i !== index);
    setCertificates(updatedCertificates);
  };

  const handleRemoveProject = (index) => {
    if (projects[index].projectInfoId) {
      // delete api
      deleteProjectInfo(projects[index]);
    }
    const updatedProjects = projects.filter((_, i) => i !== index);
    setProjects(updatedProjects);
  };


  const deleteCareer = async (career) => {
    try {
      const response = await compatApi.post('/user/deleteUserCareer', career);

      const message = await response.text();
      alert(message);

    }
    catch (error) {
      alert(error);
    }
  }

  const deleteCertificate = async (certificate) => {

    try {
      const response = await compatApi.post('/user/deleteUserCertificate', certificate);

      const message = await response.text();
      alert(message);

    }
    catch (error) {
      alert(error);
    }
  }

  const deleteProjectInfo = async (projectInfo) => {

    try {
      const response = await compatApi.post('/user/deleteUserProjectInfo', projectInfo);

      const message = await response.text();
      alert(message);

    }
    catch (error) {
      alert(error);
    }
  }


  function handleEduChange(event) {
    const {
      name,
      value,
      //type,
      //checked
    } = event.target;

    setEducation((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }


  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = {
      userEmail: personalInfo.email,
      userName: personalInfo.userName,
      birthDate: personalInfo.birthDate,
      organizationCode: personalInfo.organizationCode,
      userRole: user.userRole,
      organizationName: personalInfo.organizationName,
      department: personalInfo.department,
      position: personalInfo.position,
      experience: personalInfo.experience,
      contact: personalInfo.contact,
      emergencyContact: personalInfo.emergencyContact,
      emergencyRel: personalInfo.emergencyRel,
      userEducation: {
        finalEdu: education.finalEdu,
        graduationDate: education.graduationDate + "-01",
        schoolName: education.schoolName,
        major: education.major,
      },
      userCareers: careers.map(career => ({
        careerId: career.careerId,
        organizationName: career.organizationName,
        startDate: career.startDate,
        endDate: career.endDate,
        task: career.task,
      })),
      userCertificates: certificates.map(cert => ({
        certificateId: cert.certificateId,
        certificateName: cert.certificateName,
        acquisitionDate: cert.acquisitionDate,
      })),
      userProjectInfos: projects.map(project => ({
        projectInfoId: project.projectInfoId,
        startDate: project.startDate,
        endDate: project.endDate,
        projectName: project.projectName,
        client: project.client,
        task: project.task,
      }))
    };

    console.log(formData);

    try {
      const response = await compatApi.post('/user/updateUserResumeInfo', formData)

      const message = await response.text();
      alert(message);

      navigate("/viewResumePage", { state: { ...user } });

    }
    catch (error) {
      alert(error);
    }



  };

  return (
    <div className="container mt-5">
      {/* Personal Information Section */}
      <div className="mb-4">
        <h2>신상기록</h2>

        <table className="table table-bordered align-middle">
          <tbody>
            <tr>
              <th style={{ backgroundColor: "#f2f2f2" }}>성명</th>
              <td>
                <input
                  type="text"
                  name="userName"
                  className="form-control"
                  value={personalInfo.userName}
                  onChange={handleInputChange}
                />
              </td>
              <th style={{ backgroundColor: "#f2f2f2" }}>생년월일</th>
              <td>
                <input
                  type="date"
                  name="birthDate"
                  className="form-control"
                  value={personalInfo.birthDate}
                  onChange={handleInputChange}
                />
              </td>
            </tr>
            {!userRole === 'ADMIN' && (
              <tr>
              <th style={{ backgroundColor: "#f2f2f2" }}>소속조직</th>
              <td>
                <input
                  type="text"
                  name="organizationName"
                  className="form-control"
                  value={personalInfo.organizationName}
                  disabled
                />
              </td>
              <th style={{ backgroundColor: "#f2f2f2" }}>부서</th>
              <td>
                <input
                  type="text"
                  name="department"
                  className="form-control"
                  value={personalInfo.department}
                  onChange={handleInputChange}
                />
              </td>
              <th style={{ backgroundColor: "#f2f2f2" }}>직위</th>
              <td>
                <input
                  type="text"
                  name="position"
                  className="form-control"
                  value={personalInfo.position}
                  onChange={handleInputChange}
                />
              </td>
            </tr>
            )}
            <tr>
              <th style={{ backgroundColor: "#f2f2f2" }}>이메일</th>
              <td>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={personalInfo.email}
                  onChange={handleInputChange}
                />
              </td>
            </tr>
            <tr>
              <th style={{ backgroundColor: "#f2f2f2" }}>연락처</th>
              <td>
                <input
                  type="text"
                  name="contact"
                  className="form-control"
                  value={personalInfo.contact}
                  onChange={handleInputChange}
                />
              </td>
              <th style={{ backgroundColor: "#f2f2f2" }}>IT근무경력</th>
              <td>
                <input
                  type="text"
                  name="experience"
                  className="form-control"
                  value={personalInfo.experience}
                  onChange={handleInputChange}
                />
              </td>
            </tr>
            <tr>
              <th style={{ backgroundColor: "#f2f2f2" }}>긴급연락처</th>
              <td>
                <input
                  type="text"
                  name="emergencyContact"
                  className="form-control"
                  value={personalInfo.emergencyContact}
                  onChange={handleInputChange}
                />
              </td>
              <th style={{ backgroundColor: "#f2f2f2" }}>긴급연락처 관계</th>
              <td>
                <input
                  type="text"
                  name="emergencyRel"
                  className="form-control"
                  value={personalInfo.emergencyRel}
                  onChange={handleInputChange}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Education Section */}
      <div className="mb-4">
        <h2>학력</h2>

        <table className="table table-bordered align-middle text-center">
          <colgroup>
            <col style={{ width: '15%' }}></col>
            <col style={{ width: '15%' }}></col>
            <col style={{ width: '30%' }}></col>
            <col style={{ width: '30%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#f2f2f2" }}>최종학력</th>
              <th style={{ backgroundColor: "#f2f2f2" }}>졸업년월</th>
              <th style={{ backgroundColor: "#f2f2f2" }}>학교명</th>
              <th style={{ backgroundColor: "#f2f2f2" }}>전공</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <select
                  type="text"
                  className="form-control"
                  value={education.finalEdu}
                  name="finalEdu"
                  onChange={(e) =>
                    handleEduChange(e)
                  }
                >
                  <option value="">선택</option>
                  <option value="university">대학 졸업</option>
                  <option value="college">전문대 졸업</option>
                  <option value="highSchool">고등학교 졸업</option>
                  <option value="master">석사 취득</option>
                  <option value="doctor">박사 취득</option>
                </select>
              </td>
              <td>
                <input
                  type="month"
                  className="form-control me-2"
                  name="graduationDate"
                  value={education.graduationDate}
                  onChange={(e) =>
                    handleEduChange(e)
                  }
                />
              </td>
              <td><input
                type="text"
                name="schoolName"
                className="form-control"
                value={education.schoolName}
                onChange={(e) =>
                  handleEduChange(e)
                }
              /></td>
              <td><input
                type="text"
                name="major"
                className="form-control"
                value={education.major}
                onChange={(e) =>
                  handleEduChange(e)
                }
              /></td>
            </tr>
          </tbody>
        </table>
      </div>


      {/* Career Section */}
      <div className="mb-4">
        <div style={{ display: "flex", alignItems: "center", paddingBottom: "10px" }}>
          <h2>경력</h2>
          <div style={{ marginLeft: "auto" }}>
            <button className="btn btn-primary" onClick={handleAddCareer}>
              경력 추가
            </button>
          </div>
        </div>

        <table className="table table-bordered text-center align-middle">
          <thead>
            <tr>
              <th style={{ backgroundColor: "#f2f2f2" }}>조직명</th>
              <th style={{ backgroundColor: "#f2f2f2" }}>근무기간</th>
              <th style={{ backgroundColor: "#f2f2f2" }}>담당업무</th>
              <th style={{
                backgroundColor: "#f2f2f2",
                width: "130px", // 너비 고정
                textAlign: "center",
              }}>작업</th>
            </tr>
          </thead>
          <tbody>
            {careers.map((career, index) => (
              <tr key={index}>
                <td>

                  <div style={{ display: 'flex' }}>{career.isActive && <span>*</span>}<input
                    type="text"
                    className="form-control"
                    value={career.organizationName}
                    onChange={(e) =>
                      handleCareerChange(index, "organizationName", e.target.value)
                    }
                  /></div>
                </td>
                <td>
                  <div className="d-flex align-items-center justify-content-between">
                    <input
                      type="date"
                      className="form-control me-2"
                      value={career.startDate}
                      onChange={(e) =>
                        handleCareerChange(index, "startDate", e.target.value)
                      }
                    />
                    <span className="mx-1">~</span>
                    <input
                      type="date"
                      className="form-control"
                      value={career.endDate}
                      onChange={(e) =>
                        handleCareerChange(index, "endDate", e.target.value)
                      }
                    />
                  </div>
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={career.task}
                    onChange={(e) =>
                      handleCareerChange(index, "task", e.target.value)
                    }
                  />
                </td>
                <td>
                  <div className="button-container align-center justify-content-between">
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleRemoveCareer(index)}
                    >
                      삭제
                    </button>
                    {career.careerId && (
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleActiveCareer(index)}
                      >
                        활성화
                      </button>

                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Certificates Section */}
      <div className="mb-4">
        <div style={{ display: "flex", alignItems: "center", paddingBottom: "10px" }}>
          <h2>자격증</h2>
          <div style={{ marginLeft: "auto" }}>
            <button className="btn btn-primary" onClick={handleAddCertificate}>
              자격증 추가
            </button>
          </div>
        </div>

        <table className="table table-bordered text-center align-middle">
          <thead>
            <tr>
              <th style={{ backgroundColor: "#f2f2f2" }}>자격증명</th>
              <th style={{ backgroundColor: "#f2f2f2" }}>취득일</th>
              <th style={{
                backgroundColor: "#f2f2f2",
                width: "80px", // 너비 고정
                textAlign: "center",
              }}>작업</th>
            </tr>
          </thead>
          <tbody>
            {certificates.map((cert, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={cert.certificateName}
                    onChange={(e) =>
                      handleCertificateChange(index, "certificateName", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={cert.acquisitionDate}
                    onChange={(e) =>
                      handleCertificateChange(index, "acquisitionDate", e.target.value)
                    }
                  />
                </td>
                <td>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleRemoveCertificate(index)}
                  >
                    삭제
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Projects Section */}
      <div className="mb-4">
        <div style={{ display: "flex", alignItems: "center", paddingBottom: "10px" }}>
          <h2>최근 수행 프로젝트</h2>
          <div style={{ marginLeft: "auto" }}>
            <button className="btn btn-primary" onClick={handleAddProject}>
              프로젝트 추가
            </button>
          </div>
        </div>

        <table className="table table-bordered text-center align-middle">
          <thead>
            <tr>
              <th style={{ backgroundColor: "#f2f2f2" }}>수행기간</th>
              <th style={{ backgroundColor: "#f2f2f2" }}>프로젝트명</th>
              <th style={{ backgroundColor: "#f2f2f2" }}>고객사</th>
              <th style={{ backgroundColor: "#f2f2f2" }}>역할</th>
              <th style={{
                backgroundColor: "#f2f2f2",
                width: "80px", // 너비 고정
                textAlign: "center",
              }}>작업</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((project, index) => (
              <tr key={index}>
                <td>
                  <div className="d-flex align-items-center justify-content-between">
                    <input
                      type="date"
                      className="form-control me-2"
                      value={project.startDate}
                      onChange={(e) =>
                        handleProjectChange(index, "startDate", e.target.value)
                      }
                    />
                    <span className="mx-1">~</span>
                    <input
                      type="date"
                      className="form-control"
                      value={project.endDate}
                      onChange={(e) =>
                        handleProjectChange(index, "endDate", e.target.value)
                      }
                    />
                  </div>
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={project.projectName}
                    disabled={project.projectId}
                    onChange={(e) =>
                      handleProjectChange(index, "projectName", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={project.client}
                    disabled={project.projectId}
                    onChange={(e) =>
                      handleProjectChange(index, "client", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={project.task}
                    onChange={(e) =>
                      handleProjectChange(index, "task", e.target.value)
                    }
                  />
                </td>
                <td>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleRemoveProject(index)}
                  >
                    삭제
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="button-container-right pb-5">
        <button className="btn btn-primary" onClick={handleSubmit}>저장</button>
        <Link to="/viewResumePage" state={{ ...user }} className="btn btn-secondary">취소</Link>
      </div>
    </div>
  );
};

export default ResumePage;

